import { Box, Stack } from "@mui/material";
import { useRoles } from "../../hooks/useRoles";
import NoTableDataImageSIMP from '../../assets/image/empty-state-establecimientos-simp.png';
import NoTableDataImageBO from '../../assets/image/empty-state-establecimientos-backoffice.png';

interface EmptyTableSectionProps {
    title: string;
    description?: string;
}

const EmptyTableSection = ({title, description = ''}: EmptyTableSectionProps) => {
    const { isAdminBO, isViewerBO } = useRoles();
    return (
        <Box
            my={1}
            display="flex"
            alignItems="center"
            justifyContent="center"
            flexDirection="column"
        >
            <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{
                    '& h4': {
                        fontSize: '18px'
                    },
                    '& p': {
                        maxWidth: '360px',
                        textAlign: 'center',
                        margin: 0,
                        fontSize: '16px'
                    }
                }}
            >
                <img src={isAdminBO || isViewerBO ? NoTableDataImageBO : NoTableDataImageSIMP} />
                <h4>{title}</h4>
                {description && <p>{description}</p>}
            </Stack>
        </Box>
    );
}

export default EmptyTableSection;